import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import styles from './loginPage.css';
import { login as loginAction } from '../../data/login/actions';
import Logo from '../../assets/img/playrence-logo.png';
import User from '../../assets/svg/user.svg';
import Key from '../../assets/svg/key.svg';
import URLSearchParams from 'url-search-params';
import { CSSTransition } from 'react-transition-group';
import { isRunningOnClientSide } from '../../utils/func';


/**
 *
 * @type {React.NamedExoticComponent<{loginActions?: *, location?: *, content?: *, login?: *}>}
 */
const LoginPage = React.memo( ( { location } ) => {

    const dispatch = new useDispatch();
    const { localization: { content }, login } = useSelector( ( state ) => state );

    const handleLogin = e => {
        e.preventDefault();

        const formValues = {
            username: e.target.username.value,
            password: e.target.password.value
        };
        const params = new URLSearchParams( location.search );
        const tenant = params.get( 'tenant' );
        localStorage.setItem( 'tenant', tenant );
        dispatch( loginAction( formValues ) );
    };

    const { error, message } = login;
    return (
        <div className={ styles.wrapper }>


            <div className={ styles.logoWrap }>
                <img src={Logo} alt='Playrence Logo'  className={ styles.logo } />
            </div>
            { isRunningOnClientSide() && <CSSTransition
                in={ true }
                appear={ true }
                timeout={ 2000 }
                classNames={ {
                    appear: styles[ 'fadeInUp-appear' ],
                    appearActive: styles[ 'fadeInUp-appear-active' ]
                } }
            >
                <form
                    className={ styles.form }
                    onSubmit={ handleLogin }
                    autoComplete='off'
                >
                    <div className={ styles.blur }/>

                    <span className={ styles.heading }>
                        Login
                    </span>
                    <div className={ styles.fieldWrap }>
                        <User className={ styles.fieldIcon }/>
                        <input
                            autoFocus={ true }
                            className={ styles.input }
                            name='username'
                            placeholder={/*content.login.username*/'email' }
                            type='text'
                        />
                        {error && message && <span className={styles.wrongCred}>{message}</span>}
                    </div>
                    <div className={ styles.fieldWrap }>
                        <Key className={ styles.fieldIcon }/>
                        <input
                            className={ styles.input }
                            name='password'
                            placeholder={/*content.login.password*/'password' }
                            type='password'
                        />
                    </div>
                    <div className={ styles.forgotWrap }>
                        <Link
                            className={ styles.forgotLink }
                            to='forgot-password'
                        >
                            Forgot your password?
                        </Link>
                    </div>
                    <button type='submit' className={ styles.button }>{ content.login.login }</button>
                </form>
            </CSSTransition> }
        </div>
    );

} );

export default LoginPage;